export default "__VITE_ASSET__Dn7uY8Ea__"